export default () => ({
  id: null,
  keywords: null,
  regions: [],
  visibility: 'all'
})
